import Http from "./Http";


export async function generateMapToken() : Promise<string | null>
{
    var response = await Http.getData(`${process.env.REACT_APP_SERVER_UR}/delivery/maptoken`);
    if(response.status == 200)
        return response.data.data.token;
    return null;
}

export async function getService() : Promise<any | null>
{
    var response = await Http.getData(`${process.env.REACT_APP_SERVER_UR}/delivery/service`);
    if(response.status == 200)
        return response.data.data.service;
    return null;
}

export async function getRoute(partnerId: string) : Promise<any | null>
{
    var response = await Http.getData(`${process.env.REACT_APP_SERVER_UR}/delivery/route/${partnerId}`);
    if(response.status == 200)
        return response.data.data.route;
    return null;
}

export async function addReview(payload : any) : Promise<any | null>
{
    var response = await Http.post(`${process.env.REACT_APP_SERVER_UR}/delivery/review`, payload);
    if(response.status == 200)
        return response;
    return null;
}

export async function addIssueReport(payload : any) : Promise<any | null>
{
    var response = await Http.post(`${process.env.REACT_APP_SERVER_UR}/delivery/reportissue`, payload);
    if(response.status == 200)
        return response;
    return null;
}

export async function storeQuery(payload : any) : Promise<any | null>
{
    var response = await Http.post(`${process.env.REACT_APP_SERVER_UR}/delivery/storequery`, payload);
    if(response.status == 200)
        return response;
    return null;
}
